import React from "react";
import { FaHeart } from "react-icons/fa";
import { useCustomRouter } from "../../hooks/useCustomRouter";
import { goToExternalUrl } from "../../utils";
import {
  HeroSection,
  HeroTopRow,
  HeroContent,
  TextBlock,
  Headline,
  HeadlineAccent,
  HeroBody,
  ButtonRow,
  PurpleButton,
  YellowButton,
  GradientButton,
  HeroImage
} from "./styled.components";

const Hero: React.FC = () => {
  const customRouter = useCustomRouter();
  const goToPath = (path: string) => customRouter.append(path);

  return (
    <HeroSection>
      <HeroTopRow>
        <HeroImage
          role="img"
          aria-label="Kyah Rayne smiling outdoors at sunset"
        />

        <HeroContent>
          <TextBlock>
            <Headline>
              Food Allergy Education That Helps Communities{" "}
              <HeadlineAccent>
                Respond When Every Second Matters.
              </HeadlineAccent>
            </Headline>

            <HeroBody>
              The Kyah Rayne Foundation provides free, expert-informed training,
              practical emergency resources, and public health partnerships that
              help schools, food service teams, and communities prepare for food
              allergy emergencies.
            </HeroBody>
          </TextBlock>
        </HeroContent>
      </HeroTopRow>

      <ButtonRow>
        <PurpleButton
          onClick={() =>
            goToExternalUrl("https://vimeo.com/1083644070?fl=pl&fe=sh")
          }
        >
          View Our Impact
        </PurpleButton>

        <GradientButton onClick={() => goToPath("trainings")}>
          Take Kyah's EPICourse
        </GradientButton>

        <YellowButton onClick={() => goToPath("donate")}>
          <FaHeart />
          Donate
        </YellowButton>
      </ButtonRow>
    </HeroSection>
  );
};

export default Hero;
